/* eslint-disable max-len */
// Dependencies'
import React, {useEffect, useState} from 'react'
import {connect} from 'react-redux'
import Helpers from '../Helpers.js'

// Actions
import {storePayload} from '../actions/storePayload'
import {onSignInSuccess} from '../actions/onSignInSuccess'
import {signOut} from '../actions/signOut.js'

// Components
import {Notification, Icon} from '@lazarusai/forms-ui-components'
import FullLoadingScreen from './FullLoadingScreen.js'
import {Demo} from '@lazarusai/forms-demo'
import AuthModal from './AuthModal.js'
import RequestLoadingScreen from './RequestLoadingScreen.js'

// Styles
import '@lazarusai/forms-ui-components/dist/index.css'
import '@lazarusai/forms-demo/dist/index.css'
import '../styles/App.css'
import '../styles/Variables.css'

// Images
// import Check from '../images/check.svg'
// import Warning from '../images/warning.svg'

function App(props) {
  const [isNotificationVisible, setIsNotificationVisible] = useState(true)
  const requiresAuth = true

  /* animates notification */
  const onClickNotification = () => {
    setIsNotificationVisible(false)
    if (props.notificationTimeout) {
      clearTimeout(props.notificationTimeout)
    }
    props.storePayload({
      notificationTimeout: setTimeout(() => {
        props.storePayload({
          userMessage: null,
          notificationType: null,
          notificationIcon: null,
        })
        setIsNotificationVisible(true)
      }, 300),
    })
  }

  /* Automatically close type 2 notifications */
  useEffect(() => {
    if (props.notificationType === 2) {
      if (props.notificationTimeout) {
        clearTimeout(props.notificationTimeout)
      }
      props.storePayload({
        notificationTimeout: setTimeout(onClickNotification, 10000),
      })
    }
  }, [props.userMessage])

  useEffect(() => {
    const orgId = localStorage.getItem('lzr_orgId')
    const authKey = localStorage.getItem('lzr_authKey')
    const expiry = parseInt(localStorage.getItem('lzr_auth_expiry') || '0', 10)
    if (orgId && authKey && Date.now() < expiry) {
      props.onSignInSuccess(orgId, authKey)
    } else {
      localStorage.removeItem('lzr_orgId')
      localStorage.removeItem('lzr_authKey')
      localStorage.removeItem('lzr_auth_expiry')
      props.storePayload({isSignedIn: false, hasAttemptedSignIn: true, isLoading: false})
    }
  }, [])

  return (
    <>
      {props.isLoading && <FullLoadingScreen />}
      {props.isLoadingRequest && <RequestLoadingScreen />}
      {props.userMessage &&
        <Notification
          type={props.notificationType || 1}
          icon={
            <div className={`toggle-container ${props.notificationIcon === 'check' ? 'toggled' : ''}`}>
              <Icon
                fill='var(--colors-brand-state-success-contrast-dark)'
                icon='checkmark-outline'
              />
              <Icon
                fill='var(--colors-brand-state-warn-contrast-dark)'
                icon='alert-circle-outline'
              />
            </div>
          }
          content={props.userMessage}
          time={Helpers.timeStampToTime(Date.now())}
          isVisible={isNotificationVisible}
          onClick={onClickNotification}
          showBackdrop={props.notificationType === 3 ? true : false}
          theme='dark'
          className={'notification-class'}
        />
      }
      {!requiresAuth || (props.orgId && props.authKey) ?
        <div style={{
          position: 'relative',
          width: '100%',
          height: '100%',
        }}>
          <Demo
            orgId={props.orgId}
            authKey={props.authKey}
            showSignOut={true}
            signOut={props.signOut}
          />
        </div> :
        <AuthModal />
      }
    </>
  )
}

const mapStateToProps = (state, ownProps) => ({
  cookies: ownProps.cookies,
  userMessage: state.userReducer.userMessage,
  notificationType: state.userReducer.notificationType,
  notificationIcon: state.userReducer.notificationIcon,
  theme: state.userReducer.theme,
  isSignedIn: state.userReducer.isSignedIn,
  isLoading: state.userReducer.isLoading,
  orgId: state.userReducer.orgId,
  authKey: state.userReducer.authKey,
  isLoadingRequest: state.userReducer.isLoadingRequest,
  canceledRequests: state.userReducer.canceledRequests,
  lastRequest: state.userReducer.lastRequest,
  notificationTimeout: state.userReducer.notificationTimeout,
})

export default connect(
    mapStateToProps,
    {storePayload, onSignInSuccess, signOut},
)(App)
